import { useQuery } from "@tanstack/react-query";
import { getUnreadNotificationCount } from "@/features/notifications/notifications.api";
import type { UnreadCountResponse } from "@/features/notifications/schemas/notification.schema";

const POLL_INTERVAL_MS = 30_000;

/// Polling bell badge, matches the legacy 30s cadence (spec §10.7). The
/// shore caches in-memory 5s, so multiple-tab polling collapses on the
/// server side. Query key is intentionally narrow so the bell doesn't
/// invalidate when the list filters change.
export function useUnreadNotificationCount(workspaceId: string | undefined) {
  return useQuery<UnreadCountResponse>({
    queryKey: ["notifications", workspaceId, "unread-count"],
    queryFn: () => {
      if (!workspaceId) throw new Error("workspaceId is required");
      return getUnreadNotificationCount(workspaceId);
    },
    enabled: Boolean(workspaceId),
    refetchInterval: POLL_INTERVAL_MS,
    refetchIntervalInBackground: false,
    staleTime: 0,
  });
}
